import { LiaExchangeAltSolid } from 'react-icons/lia';
import styled from 'styled-components';

export const STituloDivider = styled.div`
    height: 1px;
    width: 100%;
    background: ${({ theme }) => theme.bg3};
    margin: 2lvh 0px;
`;

export const IconTransfer = styled(LiaExchangeAltSolid)`
    width: 100%;
    height: 6lvh;
    margin: 2lvh;
`